<script>
export default {
    name: "ViewCombinedInvoice",
    data() {
    return { 
      patient: {},
      footerMessage: {},
      visitDetail:[],
    age:0,
nationalId:0,  dateofAdmission:'',
dateofDischarge:'',
ward:'',
bed:'', 
    };
  },
    props: {

        showModal: Boolean,
        invoice: Object,
        combinedInvoice: Object,
    },

    computed: {

        // totalAmount() {

        //     if(!this.combinedInvoice.combinedPaymentnInvoiceDetails.length) return 0;
        //     this.getPatientVisitDetails(this.invoice.visitNo);
        //     return this.combinedInvoice.combinedPaymentnInvoiceDetails.map(line => parseFloat(line.amount))
        //         .reduce((sum,amount) => sum+amount);
        // },
    },

    methods: {

        printInvoice() {
            let url = `/billing/receipt-combined-payments/print`;
                url += `?patientID=${this.invoice.patientID}`;
                url += `&invoiceNo=${this.invoice.receiptnInvoiceNo}`;
    
            window.open(url, `_blank`, `CombinedInvoice`);
        },
        markAsAllocated() {

this.$root.loading = true;
this.$http.post(`Accounts/MarkMpesaAsAllocated?ReceiptId=${this.invoice.id}&TransactionRef=${this.invoice.transaction_Reference}&UserName=${this.$root.username}`)
    .then(response => {
        this.$emit('refresh');
        this.$root.loading = false;
        this.$emit('closeModal');
        window.Swal.fire({ type: 'success', title: response.data });
    }).catch(() => { this.$root.loading = false; });
},
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 w-6/12">
      <template v-slot:title>
        <h5 class="font-medium text-base"> MPESA PAYMENT DETAILS</h5> 
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap items-center">
             <div class="w-full p-1 text-center my-3">
                <h5 class="font-medium text-base uppercase">MPESA PAYMENT DETAIL</h5>
            </div>
            <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Name: {{ invoice.customer_Name}}</h5> 
                </div>
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Date: {{ invoice.trxDate |dateFormat }}</h5>
                </div>
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Transaction Ref : {{ invoice.transaction_Reference }}</h5>
                </div>
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Bill No: {{ invoice.transaction_BillNumber }}</h5>
                </div>
                
                
            </div>
            <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Paid Amount: {{ invoice.transaction_Amount}}</h5>
                </div>
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Allocated: {{ invoice.allocated_Amount}}</h5>
                </div>
                <div class="flex-1 my-1">
                    <h5 class="font-semibold text-sm">Remaining Amount : {{ invoice.remaining_Amount }}</h5>
                </div>
                 
                
                
            </div>
           
            
            
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <!-- <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Name: {{ patient.names}}</h5> 
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">VisitNO: {{ patient.visitNo }}</h5>
            </div> -->
            
        </div>
        
        <!-- <div class="w-full p-1 my-1">
            <h5 class="text-base font-bold uppercase">Mpesa Payment Details</h5>
        </div> -->
        <!-- <table class="table my-1">
            <thead class="text-sm">
                <tr>
                   
                             <th class="p-tiny">Date</th>
                             <th class="p-tiny">Ref No</th>
                             <th class="p-tiny">Payment Mode</th>
                             <th class="p-tiny">Customer Name</th>
                             <th class="p-tiny">Bill No</th>
                    
                    <th class="p-tiny">Amount Paid</th>
                    <th class="p-tiny">Amount Allocated</th>
                    <th class="p-tiny">Remaining Amount</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(invoic, idx) in invoice" :key="idx">
                   
                    
                    <td class="p-tiny flex-1">{{ invoic.trxDate | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ invoic.transaction_Reference || `-` }}</td>
                          <td class="p-tiny flex-1">{{ invoic.transaction_PaymentMode }}</td>
                          <td class="p-tiny flex-1">{{ invoic.customer_Name || `-` }}</td>
                          <td class="p-tiny flex-1">{{ invoic.transaction_BillNumber || `-` }}</td>
                           
                          <td class="p-tiny flex-1">{{ invoic.transaction_Amount| numberFormat }}</td>
                          <td class="p-tiny flex-1">{{ invoic.allocated_Amount | numberFormat}}</td>
                          <td class="p-tiny flex-1">{{ invoic.remaining_Amount| numberFormat }}</td>
                </tr>
                 
            </tbody>
        </table> -->
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-info btn-sm text-xs rounded mr-6" 
            @click.prevent="markAsAllocated">
                <i class="fa fa-check"></i> Mark as Allocated</button>
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>
